<template>
  <v-container fluid class="px-12 py-2">
    <v-row justify="center">
      <v-col cols="12">
        <v-row>
          <v-col cols="6"
            ><breadcrumbs></breadcrumbs>
            <h1>Questions</h1></v-col
          >
          <v-col cols="6" class="text-right"
            ><v-btn
              @click="navigate(null)"
              color="primary"
              outlined
              class="mt-5"
              >Add</v-btn
            ></v-col
          >
        </v-row>

        <v-text-field
          label="Filter"
          v-model="search"
          outlined
          class="mt-5"
        ></v-text-field>

        <v-checkbox
          id="deprecated-checkbox"
          color="primary"
          label="Show deprecated questions"
          v-model="showDeprecated"
        ></v-checkbox>

        <v-data-table
          :headers="headers"
          :items="filteredList"
          :search="search"
          class="och-table"
          sort-by="name"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <a href="#" @click="navigate(item.id)">
                  {{ item.text }}
                </a>
              </td>
              <td>
                {{ item.helpText }}
              </td>
              <td>
                {{ filterAnswerList("secQuestionId", item.id).length }}
              </td>
              <td>
                <v-checkbox
                  :false-value="0"
                  :true-value="1"
                  @click.stop="setDeprecationStatus(item)"
                  v-model="item.isDeprecated"
                ></v-checkbox>
              </td>
              <td>
                <delete-question-dialog
                  :disabled="isQuestionInUse(item.id)"
                  entityType="secQuestion"
                  :entityId="item.id"
                ></delete-question-dialog>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import Breadcrumbs from "../Breadcrumbs";
import DeleteQuestionDialog from "./DeleteQuestionDialog";

export default {
  components: {
    Breadcrumbs,
    DeleteQuestionDialog,
  },
  computed: {
    filteredList() {
      let filteredList;
      if (this.showDeprecated) {
        filteredList = this.list.filter(
          item => !(item.parentAnswerId || !item.isDeprecated)
        );
      } else {
        filteredList = this.list.filter(
          item => !(item.parentAnswerId || item.isDeprecated)
        );
      }
      return filteredList;
    },
    ...mapGetters({
      filterAnswerList: "secAnswer/filterByAttributeValue",
      filterQuestionByAttribute: "secQuestion/filterByAttributeValue",
      filterRolePrimaryQuestion:
        "secRolePrimarySecQuestion/filterByAttributeValue",
    }),
    ...mapState({
      answerList: state => state.secAnswer.list,
      list: state => state.secQuestion.list,
      primaryRoleQuestionList: state => state.secRolePrimarySecQuestion.list,
    }),
  },
  async created() {
    try {
      await Promise.all([
        this.getAnswerList(),
        this.getQuestionList(),
        this.getPrimaryRoleQuestionList(),
      ]);
    } catch (e) {
      this.initialLoadError();
    }
  },
  data() {
    return {
      headers: [
        {
          text: "Text",
          value: "text",
          align: "start",
        },
        {
          text: "Help Text",
          value: "helpText",
          align: "start",
          sortable: false,
        },
        {
          text: "Answers",
          value: "",
          align: "start",
          sortable: false,
        },
        {
          text: "Deprecated",
          value: "isDeprecated",
          align: "start",
          sortable: false,
        },
        {
          text: "Actions",
          value: "",
          sortable: false,
        },
      ],
      search: null,
      showDeprecated: false,
    };
  },
  methods: {
    isQuestionInUse(id) {
      const filteredAnswerList = this.filterAnswerList("secQuestionId", id);
      const filteredRolePrimaryList = this.filterRolePrimaryQuestion(
        "secQuestionId",
        id
      );

      if (
        filteredAnswerList.length === 0 &&
        filteredRolePrimaryList.length === 0
      ) {
        return false;
      }
      return true;
    },
    navigate(questionId) {
      if (questionId) {
        this.$router.push({
          name: "ochinUserSecurityQuestionForm",
          params: { questionId },
        });
        return;
      }

      this.$router.push({
        name: "ochinUserSecurityQuestionCreate",
      });
    },
    async setDeprecationStatus(item) {
      if (item.isDeprecated) {
        try {
          await this.updateDeprecationStatus(item.id, false);
          this.$notifySuccess({
            message: "Question successfully un-deprecated.",
          });
        } catch (e) {
          console.error(e);
          this.$notifyError({ message: "Could not un-deprecate question." });
        }
      } else {
        try {
          await this.updateDeprecationStatus(item.id, true);
          this.$notifySuccess({
            message: "Question successfully deprecated.",
          });
        } catch (e) {
          console.error(e);
          this.$notifyError({
            message: "Error deprecating question.",
          });
        }
      }
      try {
        await this.getQuestionList();
      } catch (e) {
        console.error(e);
      }
    },
    async updateDeprecationStatus(id, deprecate = false) {
      // Iterate over children and deprecate all child questions and answers recursively.
      const answerList = this.filterAnswerList("secQuestionId", id);
      const isDeprecated = deprecate ? 1 : 0;

      let result = [];
      for (let answer of answerList) {
        const childQuestionList = this.filterQuestionByAttribute(
          "parentAnswerId",
          answer.id
        );
        for (let question of childQuestionList) {
          // Recursively deprecating child questions.
          const returnVal = await this.updateDeprecationStatus(
            question.id,
            deprecate
          );
          result = result.concat(returnVal);
        }

        this.updateAnswer([answer.id, { isDeprecated }]);
      }

      await this.updateQuestion([id, { isDeprecated }]);

      result.push(id);

      // The returned result is an array of question and child question ids.
      return result;
    },
    ...mapActions({
      getAnswerList: "secAnswer/list",
      getQuestionList: "secQuestion/list",
      getPrimaryRoleQuestionList: "secRolePrimarySecQuestion/list",
      removePrimaryRoleQuestionAssociation: "secRolePrimarySecQuestion/remove",
      updateAnswer: "secAnswer/update",
      updateQuestion: "secQuestion/update",
    }),
  },
  notifications: {
    initialLoadError: {
      message: "Could not load initial page state. Refresh page and try again.",
      timeout: 0,
    },
  },
};
</script>
